import { featureFlagClient } from '@trello/feature-flag-client';
import { memberId } from '@trello/session-cookie';
import { isEmbeddedDocument } from '@trello/browser';

// We only care about the initial evaluation of the flag;
// If a user opts in after page load, they should refresh
// to see the workspace navigation
const isFlagEnabled = featureFlagClient.get<boolean>(
  'teamplates.web.left-nav-bar',
  false,
);

export function isWorkspaceNavigationEnabled() {
  return isFlagEnabled && !!memberId && !isEmbeddedDocument();
}
